module.exports = __webpack_public_path__ + "static/media/banner2a.2543f8ad.png";